import { useEffect, EffectCallback } from 'react';

// This hook should be used to run a function only on the component's first load
function useMountEffect(effect: EffectCallback) {
  return useEffect(effect, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useMountEffect;
